import { render, staticRenderFns } from "./RetainersModal.vue?vue&type=template&id=208087b8&scoped=true&"
import script from "./RetainersModal.vue?vue&type=script&lang=js&"
export * from "./RetainersModal.vue?vue&type=script&lang=js&"
import style0 from "./RetainersModal.vue?vue&type=style&index=0&id=208087b8&scoped=true&lang=css&"
import style1 from "./RetainersModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208087b8",
  null
  
)

export default component.exports